import { REQUEST_URL } from "../constants";
import { RequestUtil } from "../utils";

export const AuthService = {
  signIn,
  loadMe,
  verifyToken,
};

function signIn(data: { email: string; password: string }) {
  const url = REQUEST_URL.LOGIN;

  return RequestUtil.post({ url, data });
}

function verifyToken(token: string) {
  const url = REQUEST_URL.VERIFY_TOKEN;

  return RequestUtil.post({ url, data: { token } });
}

function loadMe() {
  const url = REQUEST_URL.LOAD_ME;

  return RequestUtil.get({ url });
}
